import { render, staticRenderFns } from "./postTask.vue?vue&type=template&id=ff1489e4&scoped=true"
import script from "./postTask.vue?vue&type=script&lang=js"
export * from "./postTask.vue?vue&type=script&lang=js"
import style0 from "./postTask.vue?vue&type=style&index=0&id=ff1489e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1489e4",
  null
  
)

export default component.exports